import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2, Send } from "lucide-react";
import { listAnnouncements, createAnnouncement, deleteAnnouncement } from "../adminApi";

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ title: "", body: "" });
  const [saving, setSaving] = useState(false);
  const load = async () => { setLoading(true); try { setItems(await listAnnouncements()); } catch { toast.error("Failed to load."); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);
  const post = async (e) => {
    e.preventDefault();
    if (!f.title.trim() || !f.body.trim()) return toast.error("Title and body are required.");
    setSaving(true);
    try { await createAnnouncement(f); toast.success("Published."); setF({ title: "", body: "" }); load(); }
    catch (err) { toast.error(err.message); } finally { setSaving(false); }
  };
  const del = async (id) => { try { await deleteAnnouncement(id); load(); } catch { toast.error("Delete failed."); } };
  return (
    <div data-testid="admin-announcements" className="max-w-3xl">
      <h1 className="mb-1 text-2xl font-bold text-slate-900">Announcements</h1>
      <p className="mb-6 text-sm text-slate-500">Posted announcements are visible to all students.</p>
      <form onSubmit={post} className="mb-6 flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-5">
        <input value={f.title} onChange={(e) => setF((s) => ({ ...s, title: e.target.value }))} placeholder="Title" data-testid="announcement-title" className="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-orange" />
        <textarea value={f.body} onChange={(e) => setF((s) => ({ ...s, body: e.target.value }))} placeholder="Message" rows={3} data-testid="announcement-body" className="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-orange" />
        <button type="submit" disabled={saving} data-testid="announcement-post" className="inline-flex items-center justify-center gap-2 rounded-lg bg-orange px-5 py-2.5 text-sm font-medium text-white disabled:opacity-60"><Send className="h-4 w-4" /> {saving ? "Posting…" : "Publish"}</button>
      </form>
      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div> : items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white py-14 text-center text-slate-400">No announcements yet.</div>
      ) : (
        <div className="space-y-3">{items.map((a) => (
          <div key={a.id} className="rounded-xl border border-slate-200 bg-white p-5">
            <div className="flex items-start justify-between gap-4"><div><div className="font-semibold text-slate-900">{a.title}</div><div className="mt-1 text-sm text-slate-600">{a.body}</div></div>
            <button onClick={() => del(a.id)} data-testid="announcement-delete" className="text-red-500 hover:text-red-600"><Trash2 className="h-4 w-4" /></button></div>
          </div>
        ))}</div>
      )}
    </div>
  );
}
